module.exports = __webpack_public_path__ + "static/media/logo-pc-white.ecf9eafe.png";